module.exports = __webpack_public_path__ + "img/img5.564e9e4d.png";